module.exports = __webpack_public_path__ + "static/media/ceramika.71a0c4a3.svg";